import { render, staticRenderFns } from "./NewCourt.vue?vue&type=template&id=45c7c14e"
import script from "./NewCourt.vue?vue&type=script&lang=js"
export * from "./NewCourt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports